module.exports = __webpack_public_path__ + "img/contribute-cover.22ec877c.svg";